<div class="d-flex" [ngClass]="mainClass">
  <pagination-controls (pageChange)="onLoadPageNumber($event)"
    [ngClass]="paginationClass"
    [maxSize]="maxSize"
    [nextLabel]="nextLabel"
    class="custom-pagination"
    [previousLabel]="previousLabel"
    [id]="id">
  </pagination-controls>
  <div class="pager-rows" [ngClass]="itemsPerPageClass">
    <label for="rowsPerPage"
      class="mr-sm-2"
    translate>Entries per page</label>
    <select [(ngModel)]="itemsPerPage"
      class="custom-select"
      id="rowsPerPage"
      (change)="onItemsPerPageOptionsChange($event)">
      @for (itemsCount of itemsPerPageOptions; track itemsCount) {
        <option
          [selected]="itemsCount === itemsPerPage"
          [value]="itemsCount"
          [innerText]="itemsCount">
        </option>
      }
    </select>
  </div>
</div>
